enum MacroCategoryEnum {
  BALCONY = 'BALCONY',
  DELUXE = 'DELUXE',
  INSIDE = 'INSIDE',
  OUTSIDE = 'OUTSIDE',
  SUITE = 'SUITE',
  YACHT = 'YACHT',
}

enum CabinPreferenceEnum {
  GUARANTEED = 'GUARANTEED',
  REAL = 'REAL',
}

enum AvailabilityStatusEnum {
  AVAILABLE = 'AVAILABLE',
  DENIED = 'DENIED',
}

enum DeckFromMulesoftEnum {
  DECK = 'DECK',
}

enum DiscountEnum {
  AMOUNT = 'AMOUNT',
  FLAT_RATE = 'FLAT_RATE',
  PER_DIEM = 'PER_DIEM',
  PERCENTAGE = 'PERCENTAGE',
  USER_DEFINED = 'USER_DEFINED',
}

enum PriceBasisEnum {
  PER_PERSON = 'PER_PERSON',
  PER_CABIN = 'PER_CABIN',
  PER_PASSENGER = 'PER_PASSENGER',
}

enum ApplicabilityItemEnum {
  MANDATORY = 'MANDATORY',
  SUBSTITUTABLE = 'SUBSTITUTABLE',
  OPTIONAL = 'OPTIONAL',
}
enum PriceTypeEnum {
  NIGHT = 'NIGHT',
  STAY = 'STAY',
}

enum BlockStatusEnum {
  MANUAL_FIT_FLIGHT = 'MANUAL_FIT_FLIGHT',
  OTHER = 'OTHER',
}
enum ClassCodeFlightEnum {
  BUSINESS_CLASS = 'BUSINESS_CLASS',
  FIRST_CLASS = 'FIRST_CLASS',
  PREMIUM_CLASS = 'PREMIUM_CLASS',
  ECONOMY = 'ECONOMY',
}

enum OriginTypeFlightEnum {
  AIRPORT = 'AIRPORT',
  CITY = 'CITY',
  DESTINATION = 'DESTINATION',
  Zone = 'Zone',
  ZONE = 'ZONE',
}

enum PassengerTypeEnum {
  CHILD = 'CHILD',
  ADULT = 'ADULT',
}

enum BasisInsurancePricesCruisesSearchEnum {
  BOOKING_AMOUNT = 'BOOKING_AMOUNT',
  ITINERARY_LENGTH = 'ITINERARY_LENGTH',
}

enum TypeInsurancePricesCruisesSearchEnum {
  AMOUNT = 'AMOUNT',
  PERCENTAGE = 'PERCENTAGE',
}

enum HSCChangeTypeEnum {
  INCREASE = 'increase',
  DECREASE = 'decrease',
}

enum CreateBookingWarningsEnum {
  EUROPINS_010 = 'unable_to_retrieve_insurance_price',
  UNABLE_TO_SAVE_PAYMENT_METHOD = 'unable_to_save_payment_method',
}

enum CruiseTypeIdentifier {
  WORLD_CRUISE_CANVAS_CODE = 'WOR',
  YACHT_CLUB_MACRO_CATEGORY = 'YTC',
}

enum StepName {
  PACKAGE_SELECTION = 'package-selection',
  PRICE_TYPES = 'price-types',
  OCCUPANCY = 'occupancy',
  CABIN_TYPES = 'cabin-types',
  CABIN_PREFERENCES = 'cabin-preferences',
  CATEGORIES = 'categories',
  DECKS = 'decks',
  CRUISE_SUMMARY = 'cruise-summary',
  GUEST_INFO = 'guest-info',
  CHECKOUT = 'checkout',
  ADD_ONS = 'add-ons',
  INSURANCE = 'insurance',
  THANK_YOU = 'thankyou',
}

export { MacroCategoryEnum };
export { AvailabilityStatusEnum };
export { DeckFromMulesoftEnum };
export { CabinPreferenceEnum };
export { DiscountEnum };
export { PriceBasisEnum };
export { ApplicabilityItemEnum };
export { PriceTypeEnum };
export { BlockStatusEnum };
export { ClassCodeFlightEnum };
export { OriginTypeFlightEnum };
export { PassengerTypeEnum };
export { BasisInsurancePricesCruisesSearchEnum };
export { TypeInsurancePricesCruisesSearchEnum };
export { HSCChangeTypeEnum };
export { CreateBookingWarningsEnum };
export { CruiseTypeIdentifier };
export { StepName };
